module.exports = __webpack_public_path__ + "static/Tastea9-23d6c0ffa25c4c666a3d5c5c46891d69.jpg";